"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.components = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _delay2 = _interopRequireDefault(require("lodash/delay"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _FilterLabel = require("../FilterLabel/FilterLabel");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MultiToggleSwitch = function MultiToggleSwitch(_ref) {
  var toggleId = _ref.id,
    options = _ref.options,
    className = _ref.className,
    onChange = _ref.onChange,
    icon = _ref.icon;
  var optionRefs = (0, _react.useRef)([]);
  var buttonContainerRef = (0, _react.useRef)(null);
  var topMarginObj = (0, _react.useRef)({});
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    switcherTopMargin = _useState2[0],
    setSwitcherTopMargin = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    switcherBouncing = _useState4[0],
    setSwitcherBouncing = _useState4[1];
  var handleClick = function handleClick(e, id, disabled) {
    if (disabled) {
      setSwitcherTopMargin(topMarginObj.current[id]);
      return;
    }
    onChange(id);
  };

  /**
   * Вычисляем отступы для бегунка после того, как рефы опций присвоились
   */
  (0, _react.useEffect)(function () {
    var optionElems = optionRefs.current;
    var totalHeight = 0;
    if (!buttonContainerRef.current) return;
    var buttonContainerStyle = window.getComputedStyle(buttonContainerRef.current);
    var borderWidth = Number(buttonContainerStyle.borderWidth.slice(0, -2));
    var marginEntries = optionElems.map(function (elem, index, arr) {
      var currentElemHeight = elem.getBoundingClientRect().height;
      var currentTotalHeight = totalHeight;
      var optionMarginBottom = Number(window.getComputedStyle(elem).marginBottom.slice(0, -2));

      /**
       * Вычисляем величину промежутка между лейблами - у предпоследнего
       * элемента он меньше, так как ButtonContainer имеет отступ снизу
       */
      var gap = index === arr.length - 2 ? -borderWidth : optionMarginBottom;
      totalHeight += currentElemHeight + gap;
      return [elem.id, currentTotalHeight];
    });
    topMarginObj.current = Object.fromEntries(marginEntries);
  }, [optionRefs.current]);
  var selectedOption = options.find(function (_ref2) {
    var selected = _ref2.selected;
    return selected;
  });
  (0, _react.useEffect)(function () {
    if (selectedOption) {
      setSwitcherTopMargin(topMarginObj.current[selectedOption.id]);
    }
  }, [options]);

  /**
   * Обработка клика на дизейбленную опцию
   */
  (0, _react.useEffect)(function () {
    if (selectedOption && switcherTopMargin !== topMarginObj.current[selectedOption.id] && optionRefs.current.length !== 0) {
      (0, _delay2["default"])(function () {
        setSwitcherTopMargin(topMarginObj.current[selectedOption.id]);
        setSwitcherBouncing(true);
      }, 300);
    }
  }, [switcherTopMargin]);
  (0, _react.useEffect)(function () {
    (0, _delay2["default"])(function () {
      return setSwitcherBouncing(false);
    }, 700);
  }, [switcherBouncing]);
  return /*#__PURE__*/_react["default"].createElement(SwitchContainer, {
    className: className,
    id: toggleId
  }, /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
    ref: buttonContainerRef
  }, /*#__PURE__*/_react["default"].createElement(IconContainer, null, icon), /*#__PURE__*/_react["default"].createElement(PinComponent, {
    topMargin: switcherTopMargin,
    bouncing: switcherBouncing
  }, selectedOption && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) === 1 && /*#__PURE__*/_react["default"].createElement(IconContainer, null, icon))), /*#__PURE__*/_react["default"].createElement(LabelsContainer, null, options.map(function (_ref3, idx) {
    var id = _ref3.id,
      labelComponent = _ref3.labelComponent,
      disabled = _ref3.disabled;
    return /*#__PURE__*/_react["default"].createElement(OptionContainer, {
      id: String(id),
      key: id,
      onClick: function onClick(e) {
        return handleClick(e, id, disabled);
      },
      ref: function ref(el) {
        if (el) {
          optionRefs.current[idx] = el;
        }
      },
      first: idx === 0
    }, labelComponent);
  })));
};
var SwitchContainer = _styledComponents["default"].div.withConfig({
  displayName: "MultiToggleSwitch__SwitchContainer",
  componentId: "sc-1tskxsn-0"
})(["display:flex;position:relative;"]);
var ButtonContainer = _styledComponents["default"].div.withConfig({
  displayName: "MultiToggleSwitch__ButtonContainer",
  componentId: "sc-1tskxsn-1"
})(["position:absolute;border-radius:30px;border:1px solid ", ";margin:0 6px 8px 0;height:calc(100% - 8px);"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyLight;
});
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "MultiToggleSwitch__IconContainer",
  componentId: "sc-1tskxsn-2"
})(["position:absolute;width:100%;height:32px;display:flex;justify-content:center;"]);
var bounce = (0, _styledComponents.keyframes)(["  0%,20%,50%,80%,100%{transform:translateY(0);}40%{transform:translateY(-7px);}60%{transform:translateY(-4px);}"]);
var PinComponent = _styledComponents["default"].div.withConfig({
  displayName: "MultiToggleSwitch__PinComponent",
  componentId: "sc-1tskxsn-3"
})(["width:32px;height:32px;border-radius:50%;background-color:", ";position:relative;top:", "px;transition:all 0.2s;box-shadow:1px 2px 6px 2px rgb(180 180 180 / 80%);z-index:2;", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var topMargin = _ref6.topMargin;
  return topMargin || 0;
}, function (_ref7) {
  var bouncing = _ref7.bouncing;
  return bouncing && (0, _styledComponents.css)(["animation-name:", ";animation-duration:0.5s;animation-fill-mode:both;"], bounce);
});
var LabelsContainer = _styledComponents["default"].div.withConfig({
  displayName: "MultiToggleSwitch__LabelsContainer",
  componentId: "sc-1tskxsn-4"
})(["z-index:1;"]);
var OptionContainer = _styledComponents["default"].div.withConfig({
  displayName: "MultiToggleSwitch__OptionContainer",
  componentId: "sc-1tskxsn-5"
})(["cursor:pointer;padding:0 0 0 38px;&:not(:last-child){margin-bottom:8px;}", "{overflow:initial;}", "{position:relative;overflow:initial;", "}"], _FilterLabel.StyledFilterLabel, _FilterLabel.StyledItemNameContainer, function (_ref8) {
  var first = _ref8.first;
  return !first && (0, _styledComponents.css)(["&::before{content:'';left:-24px;top:0.5em;box-sizing:border-box;position:absolute;width:4px;height:4px;border-radius:50%;border:1px solid gray;}"]);
});
var components = exports.components = {
  IconContainer: IconContainer,
  ButtonContainer: ButtonContainer,
  PinComponent: PinComponent,
  LabelsContainer: LabelsContainer,
  OptionContainer: OptionContainer
};
var _default = exports["default"] = MultiToggleSwitch;